import { Directive, HostBinding, forwardRef, OnInit, HostListener, inject, input } from '@angular/core';
import { Dimensions, Display } from '../models';
import { ImageStateService } from '../services';
import { PLACEHOLDER_IMAGE_IMAGE } from '../../index';
import { explicitEffect } from 'ngxtension/explicit-effect';

@Directive({
  selector: '[cueProgressiveImage]',
  standalone: true,
  providers: [
    {
      provide: Dimensions,
      useExisting: forwardRef(() => ProgressiveImageDirective),
    },
  ],
  host: {
    '[attr.src]': '_src',
  },
})
export class ProgressiveImageDirective implements OnInit, Dimensions {
  private placeholderImage = inject<string>(PLACEHOLDER_IMAGE_IMAGE, { optional: true });
  private imageState = inject(ImageStateService);
  @HostBinding('style.display') display = Display.none;
  @HostBinding('style.width') width: number;
  @HostBinding('style.height') height: number;
  @HostBinding('style.max-height') maxHeight: number;

  protected _src: string;

  src = input<string>();
  setSrcFromInput = explicitEffect([this.src], ([src]) => {
    this.imageState.emitLoading();
    this._src = src;
  });

  @HostListener('load')
  onLoad() {
    this.imageState.emitLoaded();
  }

  @HostListener('error')
  onError() {
    this.imageState.emitError();
  }

  ngOnInit() {
    this.imageState.isLoaded$.subscribe((loaded) => {
      if (loaded) {
        this.display = Display.flex;
      } else {
        if (this.placeholderImage) {
          this.display = Display.flex;
          this._src = this.placeholderImage;
        } else {
          this.display = Display.none;
        }
      }
    });
  }
}
